<template>
  <div ref="row" class="row" :style="`height:${rowHeight}px;`">
    <!-- viewer -->
    <div ref="viewerCol" class="col-7 h-100"
      :style="`background-color: gray; background-clip: content-box; padding: 0px ${innerPadding / 2}px 0px ${swiperLRPadding}px;`"
      @mouseover="viewerCol.onMouseOver = true" @mouseleave="viewerCol.onMouseOver = false">
      <div class="no-scrollbar" style="height: 100%; width: 100%; overflow-x: hidden; position: relative"
        @touchstart="viewerTouchStart" @touchmove.prevent="viewerTouchMove" @touchend="viewerTouchEnd">
        <div class="d-flex flex-column flex-wrap h-100 no-scrollbar">
          <div v-for="(image, index) in images" :key="index" :style="`height: ${rowHeight}px; width: ${viewerCol.width - swiperLRPadding - innerPadding / 2}px; transform: translate3d(-${imageIndex * (viewerCol.width - swiperLRPadding - innerPadding / 2) + (viewerTouchMoveXs.start - viewerTouchMoveXs.end)
            }px, 0px, 0px); transition-duration:${viewerDuration}ms`">
            <img ref="viewerImage" :src="images[index]" style="width: 100%; height: 100%; object-fit: cover" />
          </div>
        </div>
        <!-- Left Button -->
        <Transition>
          <svg width="18" height="45" viewBox="0 0 18 45" fill="none" xmlns="http://www.w3.org/2000/svg"
            :style="`position: absolute; left: 16px; top: calc(50% - 22.5px); cursor: pointer; user-select: none;`"
            @click="clickViewerLeft" v-show="viewerCol.onMouseOver && imageIndex !== 0">
            <path d="M1 22.5172L17 1" stroke="#FEFEFE" />
            <path d="M17 44.0343L1 22.5171" stroke="#FEFEFE" />
          </svg>
        </Transition>
        <!-- Right Button -->
        <Transition>
          <svg width="18" height="45" viewBox="0 0 18 45" fill="none" xmlns="http://www.w3.org/2000/svg"
            :style="`position: absolute; right: 16px; top: calc(50% - 22.5px); cursor: pointer; user-select: none;`"
            @click="clickViewerRight" v-show="viewerCol.onMouseOver && images.length - 1 !== imageIndex">
            <path d="M17 22.5172L1 1" stroke="#FEFEFE" />
            <path d="M1 44.0343L17 22.5171" stroke="#FEFEFE" />
          </svg>
        </Transition>
      </div>
    </div>
    <!-- thumbnails -->
    <div ref="thumbnailsCol" class="col-5 h-100" :style="`padding: 0px ${swiperLRPadding}px 0px ${innerPadding / 2}px;`"
      @mouseover="thumbnailsCol.onMouseOver = true" @mouseleave="thumbnailsCol.onMouseOver = false">
      <div style="height: 100%; width: 100%; overflow-x: hidden; position: relative" @touchstart="thumbnailsTouchStart"
        @touchmove.prevent="thumbnailsTouchMove" @touchend="thumbnailsTouchEnd">
        <div class="d-flex flex-column flex-wrap h-100" :style="`transform: translate3d(-${thumbnailColumnIndex * thumbnailOffsetWidth + (thumbnailsTouchMoveXs.start - thumbnailsTouchMoveXs.end)
          }px, 0px, 0px);  transition-duration:${thumbnailsDuration}ms`">
          <div v-for="(image, index) in images" :key="index"
            :style="`height: ${thumbnailOffsetHeight}px; width: ${thumbnailOffsetWidth}px; padding: ${thumbnailPaddingValue(index)};`">
            <img ref="thumbnailImage" :src="images[index]"
              :style="`width: 100%; height: 100%; object-fit: cover; opacity: ${imageIndex === index ? '0.5' : '1'};`"
              @click="clickThumbnail(index)" />
          </div>
        </div>
        <!-- Left Button -->
        <Transition>
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"
            :style="`position: absolute; left: ${innerPadding}px; top: calc(50% - 12.5px); cursor: pointer; user-select: none;`"
            @click="clickThumbnailsLeft" v-show="thumbnailsCol.onMouseOver && thumbnailColumnIndex !== 0">
            <rect x="23.5" y="24.3013" width="23" height="23.8015" transform="rotate(180 23.5 24.3013)" fill="#FEFEFE"
              stroke="#F0F0F0" />
            <path d="M14 17.4526L9 12.4005L14 7.34827" stroke="#2D2E31" stroke-width="2" />
          </svg>
        </Transition>
        <!-- Right Button -->
        <Transition>
          <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"
            :style="`position: absolute; right: 0px; top: calc(50% - 12.5px); cursor: pointer; user-select: none;`"
            @click="clickThumbnailsRight"
            v-show="thumbnailsCol.onMouseOver && thumbnailColumnIndex < Math.ceil(images.length / 3) - 1">
            <rect x="0.5" y="-0.5" width="23" height="23.8015"
              transform="matrix(1 8.03043e-08 9.51722e-08 -1 4.75861e-08 23.8018)" fill="#FEFEFE" stroke="#F0F0F0" />
            <path d="M10 17.4531L15 12.4009L10 7.34876" stroke="#2D2E31" stroke-width="2" />
          </svg>
        </Transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StudioSwiper",
  components: {},
  props: {
    images: {
      type: Array,
      require: true,
      default: () => [],
    },
  },
  data() {
    return {
      imageIndex: 0,
      thumbnailColumnIndex: 0,
      par: 1210 / 500,
      row: {
        width: 3840,
      },
      viewerCol: {
        width: 0,
        height: 0,
        onMouseOver: false,
      },
      thumbnailsCol: {
        onMouseOver: false,
      },
      innerPadding: 3,
      swiperLRPadding: 5,
      duration: 500,
      viewerTouchMoveXs: {
        start: 0,
        end: 0,
      },
      thumbnailsTouchMoveXs: {
        start: 0,
        end: 0,
      },
      init: true,
    };
  },
  mounted() {
    this.row.width = this.$refs.row.offsetWidth;
    this.viewerCol.width = this.$refs.viewerCol.offsetWidth;
    this.viewerCol.height = this.$refs.viewerCol.offsetHeight;
    window.addEventListener("resize", this.handleResize);

    // row.width を大きめに設定することで開始時の表示ブレが低減するが、サイズが狂うことがあるので再度読み込んで対応
    this.$nextTick(() => {
      this.row.width = this.$refs.row.offsetWidth;
      this.viewerCol.width = this.$refs.viewerCol.offsetWidth;
      this.viewerCol.height = this.$refs.viewerCol.offsetHeight;
    });
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    viewerDuration() {
      return this.init || this.viewerTouchMoveXs.start !== this.viewerTouchMoveXs.end ? 0 : this.duration;
    },
    thumbnailsDuration() {
      return this.init || this.thumbnailsTouchMoveXs.start !== this.thumbnailsTouchMoveXs.end ? 0 : this.duration;
    },
    rowHeight() {
      return this.row.width / this.par;
    },
    thumbnailOffsetHeight() {
      return this.rowHeight / 3;
    },
    thumbnailOffsetWidth() {
      return ((this.row.width / 12) * 5) / 2;
    },
  },
  methods: {
    handleResize() {
      this.row.width = this.$refs.row.offsetWidth;
      this.viewerCol.width = this.$refs.viewerCol.offsetWidth;
      this.viewerCol.height = this.$refs.viewerCol.offsetHeight;
    },
    thumbnailPaddingValue(index) {
      const rowNumber = index % 3;
      switch (rowNumber) {
        case 0:
          return `0px ${this.innerPadding}px ${this.innerPadding}px ${this.innerPadding}px`;
        case 1:
          return `${this.innerPadding}px ${this.innerPadding}px ${this.innerPadding}px ${this.innerPadding}px`;
        case 2:
          return `${this.innerPadding}px ${this.innerPadding}px 0px ${this.innerPadding}px`;
      }
    },
    clickThumbnail(index) {
      this.init = false;
      this.imageIndex = index;
    },
    clickViewerLeft() {
      this.init = false;
      this.imageIndex = Math.max(0, this.imageIndex - 1);
      this.thumbnailColumnIndex = Math.floor(this.imageIndex / 3);
    },
    clickViewerRight() {
      this.init = false;
      this.imageIndex = Math.min(this.images.length - 1, this.imageIndex + 1);
      this.thumbnailColumnIndex = Math.floor(this.imageIndex / 3);
    },
    clickThumbnailsLeft() {
      this.init = false;
      this.thumbnailColumnIndex = Math.max(0, this.thumbnailColumnIndex - 1);
    },
    clickThumbnailsRight() {
      this.init = false;
      this.thumbnailColumnIndex = Math.min(Math.ceil(this.images.length / 3) - 1, this.thumbnailColumnIndex + 1);
    },
    viewerTouchStart(e) {
      this.init = false;
      this.viewerTouchMoveXs.start = e.touches[0].pageX;
      this.viewerTouchMoveXs.end = e.touches[0].pageX;
    },
    viewerTouchMove(e) {
      this.viewerTouchMoveXs.end = e.touches[0].pageX;
    },
    viewerTouchEnd() {
      //半分ずらしたらindex変更
      if (this.viewerTouchMoveXs.start - this.viewerTouchMoveXs.end > this.viewerCol.width / 2) this.clickViewerRight();
      if (this.viewerTouchMoveXs.end - this.viewerTouchMoveXs.start > this.viewerCol.width / 2) this.clickViewerLeft();
      this.viewerTouchMoveXs.start = 0;
      this.viewerTouchMoveXs.end = 0;
    },
    thumbnailsTouchStart(e) {
      this.init = false;
      this.thumbnailsTouchMoveXs.start = e.touches[0].pageX;
      this.thumbnailsTouchMoveXs.end = e.touches[0].pageX;
    },
    thumbnailsTouchMove(e) {
      this.thumbnailsTouchMoveXs.end = e.touches[0].pageX;
    },
    thumbnailsTouchEnd() {
      //半分ずらしたら表示位置変更
      if (this.thumbnailsTouchMoveXs.start - this.thumbnailsTouchMoveXs.end > (this.row.width - this.viewerCol.width) / 2) this.clickThumbnailsRight();
      if (this.thumbnailsTouchMoveXs.end - this.thumbnailsTouchMoveXs.start > (this.row.width - this.viewerCol.width) / 2) this.clickThumbnailsLeft();
      this.thumbnailsTouchMoveXs.start = 0;
      this.thumbnailsTouchMoveXs.end = 0;
    },
  },
};
</script>

<style scoped>
.no-scrollbar {
  scrollbar-width: none;
  /*Firefox対応のスクロールバー非表示コード*/
  -ms-overflow-style: none;
  /*Internet Explore対応のスクロールバー非表示コード*/
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
  /*Google Chrome、Safari、Microsoft Edge対応のスクロールバー非表示コード*/
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter,
.v-leave-to {
  opacity: 0;
}
</style>
